import { __awaiter, __generator, __read, __spreadArray } from "tslib";
import { BufferUsage } from '@antv/g-plugin-webgl-renderer';
import { Target } from './interface';
var platformString2Target = {
  WebGL1: Target.GLSL100,
  WebGL2: Target.GLSL450,
  WebGPU: Target.WGSL
};

var Kernel =
/** @class */
function () {
  function Kernel(device, _a) {
    var computeShader = _a.computeShader,
        bundle = _a.bundle;
    this.buffers = [];
    this.device = device;
    this.computeShader = computeShader;
    this.bundle = bundle;
    this.init();
  }

  Kernel.prototype.init = function () {
    var target = platformString2Target[this.device.queryVendorInfo().platformString];

    if (this.computeShader) {
      this.bundle = {
        shaders: {
          WGSL: this.computeShader,
          GLSL450: '',
          GLSL100: ''
        },
        context: {
          name: '',
          dispatch: [0, 0, 0],
          threadGroupSize: [0, 0, 0],
          maxIteration: 1,
          needPingpong: false,
          output: {
            name: ''
          },
          uniforms: [],
          defines: [],
          globalDeclarations: []
        }
      };
    }

    var program = this.device.createProgramSimple({
      preprocessedCompute: this.bundle.shaders[target]
    });
    this.computePipeline = this.device.createComputePipeline({
      program: program,
      bindingLayouts: [],
      inputLayout: null
    });
  };
  /**
   * set or update buffer by binding number,
   * it should match binding declared in compute shader
   */


  Kernel.prototype.setBinding = function (binding, buffer) {
    // @ts-ignore
    var usage = buffer.usage;
    var isUniform = usage & BufferUsage.UNIFORM;
    var isWritable = usage & BufferUsage.COPY_SRC; // search by binding

    var existed = this.buffers.find(function (buffer) {
      return buffer.binding === binding;
    });

    if (existed) {
      existed.buffer.destroy();
      this.buffers.splice(this.buffers.indexOf(existed), 1);
    }

    this.buffers.push({
      name: '',
      buffer: buffer,
      // @ts-ignore
      wordCount: buffer.size / 4,
      binding: binding,
      bindingType: isUniform ? 'uniform' : isWritable ? 'storage' : 'read-only-storage',
      group: 0 // fixed group 0

    });
    return null;
  };

  Kernel.prototype.dispatch = function (x, y, z) {
    if (y === void 0) {
      y = 1;
    }

    if (z === void 0) {
      z = 1;
    }

    var dispatchParams;

    if (Array.isArray(x)) {
      dispatchParams = x;
    } else {
      dispatchParams = [x, y, z];
    }

    var computePass = this.device.createComputePass({});
    computePass.setPipeline(this.computePipeline);
    var uniforms = this.buffers.filter(function (_a) {
      var bindingType = _a.bindingType;
      return bindingType === 'uniform';
    });
    var storages = this.buffers.filter(function (_a) {
      var bindingType = _a.bindingType;
      return bindingType !== 'uniform';
    });
    var bindings = this.device.createBindings({
      pipeline: this.computePipeline,
      bindingLayout: {
        numUniformBuffers: uniforms.length,
        storageEntries: storages.map(function (_a) {
          var bindingType = _a.bindingType;
          return {
            type: bindingType
          };
        })
      },
      uniformBufferBindings: uniforms.map(function (_a) {
        var buffer = _a.buffer,
            wordCount = _a.wordCount;
        return {
          buffer: buffer,
          wordCount: wordCount
        };
      }),
      storageBufferBindings: storages.map(function (_a) {
        var buffer = _a.buffer,
            wordCount = _a.wordCount;
        return {
          buffer: buffer,
          wordCount: wordCount
        };
      })
    }); // fixed bind group 0

    computePass.setBindings(0, bindings);
    computePass.dispatch.apply(computePass, __spreadArray([], __read(dispatchParams), false));
    this.device.submitPass(computePass);
  };
  /**
   * readback buffer async
   */


  Kernel.prototype.readBuffer = function (buffer) {
    return __awaiter(this, void 0, void 0, function () {
      var readback;
      return __generator(this, function (_a) {
        readback = this.device.createReadback();
        return [2
        /*return*/
        , readback.readBuffer(buffer)];
      });
    });
  };

  Kernel.prototype.destroy = function () {
    this.buffers.forEach(function (_a) {
      var buffer = _a.buffer;
      buffer.destroy();
    });
  };

  return Kernel;
}();

export { Kernel };